import { useEffect, useState } from "react";


// components
import PageLayout from "../components/PageLayout";
import QuoteCard from "../components/Quote";
import CurrenlyReadingCard from "../components/CurrentlyReadingCard";
import BestSellerCard from "../components/BestSellerCard";

import YearCard from "../components/YearCard";

// icons
import IconComponent from "../components/Icon";
import { FaMedal } from "react-icons/fa";
import { TbWheel } from "react-icons/tb";
import { PiListHeartBold } from "react-icons/pi";

// services
import axiosInstance from "../api/apiClient";

// functions
import { useNavigate } from "react-router-dom";


const Dashboard = () => {
  const [library, setLibrary] = useState([]);
  const [currentlyReading, setCurrentlyReading] = useState({});
  const navigate = useNavigate();

    const getLibraryData = async () => {
      await axiosInstance.get('/getUserBooks').then((data:any) => {
        const cr = data?.find((book: any) => book['Exclusive Shelf'] === 'currently-reading');

        setLibrary(data);
        setCurrentlyReading(cr);
      });
    };

    useEffect(() => {
      getLibraryData();
    }, []);


    return (
    <PageLayout
        headerText="Explore"
      >
        <BestSellerCard />

        <div className="grid md:grid-cols-2 grid-cols-1 gap-x-[40px] mt-[40px] cursor-pointer">
          <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20"  onClick={() => navigate('/bookshelf?type=tbr')}>
            <div className="flex justify-between items-center h-full">
              <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                TBR
              </h1>
              <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={PiListHeartBold} />
            </div>
          </div>
          <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 cursor-pointer md:mt-0 mt-[40px]"  onClick={() => navigate('/wheel')}>
            <div className="flex justify-between items-center h-full">
              <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                Spin Your Next Read
              </h1>
              <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={TbWheel} />
            </div>
          </div>
        </div>

        <QuoteCard/>

        <div className="grid md:grid-cols-2 grid-cols-1 mt-[40px] gap-x-[40px] mb-[40px]">
          <CurrenlyReadingCard book={currentlyReading} refreshLibrary={() => getLibraryData()} />
          <div className="md:mt-0 mt-[40px]">
            <YearCard library={library} />
          </div>
        </div>
      </PageLayout>
    );
}

export default Dashboard;